import React from 'react'

import FAIcon from '../../../../Theme/FAIcon'
import { FA_ICONS } from '../../../../Theme/font-awesome-icon-constants'

const PrefabRatingIconsWrapper = ({ length, rating, isDynamicIcon = false, icon, size = 20 }) =>
  [...Array(length).keys()].map((val) => (
    <FAIcon
      key={val}
      iconClassName={
        isDynamicIcon
          ? rating >= val + 1
            ? FA_ICONS.FILLED_STAR
            : rating >= val + 0.5
            ? FA_ICONS.HALF_STAR
            : FA_ICONS.EMPTY_STAR
          : icon
      }
      color={isDynamicIcon ? 'secondary.main' : 'text.tertiary'}
      iconFontSize={size}
    />
  ))

export default PrefabRatingIconsWrapper
